export const discordLink = 'https://discord.gg/3XwR35q29B';
export const githubSponsorsLink = 'https://github.com/sponsors/avafloww';
export const githubMainRepoLink = 'https://github.com/CrystallineTools/Thaliak';